"use client";
import { handleCampaignID } from "@/lib/utils";
import { ensureCtwCode } from "@/lib/ctw/mintClient";
import { usePathname, useSearchParams } from "next/navigation";
import { useEffect, useMemo } from "react";
import { useUserTracking, useAnalytics } from "@/contexts/AppStateContext";

const RouterChangeDetect = () => {
  const pathname = usePathname();
  const searchParams = useSearchParams();

  const { setUserTracking } = useUserTracking();
  const { incrementPageViews } = useAnalytics();

  const campaignId = useMemo(() => {
    if (typeof window !== "undefined") {
      return handleCampaignID();
    }
    return null;
  }, [searchParams]);

  useEffect(() => {
    if (campaignId) {
      setUserTracking({ campaignId });
    } else {
      if (typeof window !== "undefined") {
        sessionStorage.removeItem("WA_MSG_GEN_TOKEN");
      }
    }
  }, [campaignId, setUserTracking]);

  useEffect(() => {
    incrementPageViews();
  }, [pathname, incrementPageViews]);

  // mint the CTW source code at browser idle — never on the critical path
  useEffect(() => {
    const w = window as typeof window & {
      requestIdleCallback?: (_cb: () => void) => number;
      cancelIdleCallback?: (_handle: number) => void;
    };
    let handle: number;
    if (w.requestIdleCallback) {
      handle = w.requestIdleCallback(() => void ensureCtwCode());
      return () => w.cancelIdleCallback?.(handle);
    }
    handle = window.setTimeout(() => void ensureCtwCode(), 3000);
    return () => clearTimeout(handle);
  }, [searchParams]);

  return <></>;
};

export default RouterChangeDetect;
